uic-input-field-number {
    display: inline-flex;
    min-width: var(--uic-input-field-min-width);

    > uic-input-field {
        flex: 1 1 auto;
    }
}
